import ApiClient from '@/plugins/AxiosPlugin'

export default {
    namespaced: true,
    state: {
        lineItemNumbersToSave: [],
        confirmationData: {}
    },
    actions: {
        updatePONumber: updatePONumber
    },
    mutations: {
        updateLineItemNumbersToSave: function(state, payload) {
            for(var i = 0; i < state.lineItemNumbersToSave.length; i++) {
                if(state.lineItemNumbersToSave[i]["sapLineItemNumbers"].toString() === payload["sapLineItemNumbers"].toString()) {
                    state.lineItemNumbersToSave.splice(i, 1);
                    break;
                }
            }

            state.lineItemNumbersToSave.push(payload);
        },
        setConfirmationData: function(state, payload) {
            state.confirmationData = payload
        }
    },
    getters: {
        getLineItemNumbersToSave: function(state) {
            return state.lineItemNumbersToSave;
        },
        getConfirmationData: function(state) {
            return state.confirmationData;
        }
    }
}

function updatePONumber(context, payload) {
    return new Promise((resolve, reject) => {
        const url = context.rootState.settings.update_po_number;
        let formData = new FormData();
        let lineItemsParams = [];
        context.state.lineItemNumbersToSave.forEach(lineItem => {
            let lineItemParam = {
                'hasPurchaseOrderNumberUpdated': lineItem["hasPurchaseOrderNumberUpdated"],
                'purchaseOrderNumberValue': lineItem["purchaseOrderNumberValue"],
                'sapLineItemNumbers': lineItem["sapLineItemNumbers"]
            }
            lineItemsParams.push(lineItemParam);
        });
        formData.append("lineItemsParams", JSON.stringify(lineItemsParams));

        return ApiClient.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch(function(error) {
            reject(error);
        })
        .finally(() => {
            context.state.lineItemNumbersToSave = [];
        });
    });
}